export default __webpack_public_path__ + "assets/pdf/eLogbook_AirFrance_P3.ece81b41.pdf";